import { useState, useEffect } from 'react';
import api from '../services/api';
import { useT } from '../i18n';

// Zeigt die Vertretung eines Urlaubsantrags und erlaubt, sie aus dem Team zu wählen.
export default function VertretungSelect({ request, editable = true, onChanged }) {
  const t = useT();
  const [editing, setEditing] = useState(false);
  const [kandidaten, setKandidaten] = useState([]);
  const [auswahl, setAuswahl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!editing) return;
    api.get('/teams/vertretung/vorschlaege', {
      params: { start_date: request.start_date, end_date: request.end_date, user_id: request.user_id },
    }).then((res) => setKandidaten(res.data))
      .catch((err) => setError(err.response?.data?.detail       || t('vacation.substitute.error.load')));
        }, [t, editing, request.start_date, request.end_date, request.user_id]);

  const speichern = async () => {
    if (!auswahl) return;
    setError('');
    try {
      if (request.status === 'APPROVED' && !window.confirm(t('vacation.substitute.reapprovalConfirm'))) return;
      await api.put(`/vacation/requests/${request.id}/substitute`, { substitute_id: Number(auswahl) });
      setEditing(false);
      if (onChanged) onChanged();
    } catch (err) {
      setError(err.response?.data?.detail || t('vacation.substitute.error.save'));
    }
  };

  const anzeige = request.substitute_name
    ? <span><i className="bi bi-person-check me-1" />{request.substitute_name}</span>
    : <span className="text-muted">–</span>;

  if (!editable || request.status === 'REJECTED') return anzeige;
  if (!editing) {
    return (
      <div className="d-flex align-items-center gap-2">
        {anzeige}
        <button className="btn btn-sm btn-outline-secondary" onClick={() => setEditing(true)} title={t('vacation.substitute.set')}>
          <i className="bi bi-pencil" />
        </button>
      </div>
    );
  }
  return (
    <div>
      <div className="input-group input-group-sm">
        <select className="form-select" value={auswahl} onChange={(e) => setAuswahl(e.target.value)}>
          <option value="">{t('vacation.substitute.pick')}</option>
          {kandidaten.map((k) => (
            <option key={k.user_id} value={k.user_id} disabled={!k.verfuegbar}>
              {k.verfuegbar ? k.name : t('vacation.substitute.unavailable', { name: k.name, reason: k.grund })}
            </option>
          ))}
        </select>
        <button className="btn btn-primary" onClick={speichern}         disabled={!auswahl}>{t('vacation.substitute.save')}</button>
                <button className="btn btn-outline-secondary" onClick={() => setEditing(false)}>{t('vacation.substitute.cancel')}</button>
      </div>
      {request.status === 'APPROVED' && <div className="text-warning small mt-1"><i className="bi bi-exclamation-triangle me-1" />{t('vacation.substitute.reapprovalHint')}</div>}
      {kandidaten.length === 0 && <small className="text-muted">{t('vacation.substitute.none')}</small>}
      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
}
